import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import api from "@/lib/api";

const HERO = "https://static.prod-images.emergentagent.com/jobs/b659007a-b26e-4c48-80c7-ae6e37053ed8/images/77129cbb523c421d44bc7439a9f1643b76f56a8817039031927f3736d4f01e55.png";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [branding, setBranding] = useState({
    title: "Familientreffen",
    subtitle: "Ebel 2026",
    login_subtitle: "Bitte gib das Familien-Passwort ein, um die Einladung zu öffnen.",
  });

  useEffect(() => {
    api.get("/branding").then((r) => setBranding(r.data)).catch(() => {});
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(pw);
      const dest = location.state?.from?.pathname || "/";
      navigate(dest, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Anmeldung fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4">
      <div
        className="absolute inset-0 -z-10 paper-grain"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(253,251,247,0.85), rgba(253,251,247,0.95)), url(${HERO})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="w-full max-w-md fade-in">
        <div className="text-center mb-10">
          <p className="label-eyebrow mb-3">Privater Bereich</p>
          <h1 className="font-serif text-5xl lg:text-6xl tracking-tight text-[#1A1C19] leading-[1.05]">
            {branding.title}<br />
            <span className="italic text-[#48634A]">{branding.subtitle}</span>
          </h1>
          <div className="divider-ornament max-w-xs mx-auto mt-6">
            <Lock className="w-4 h-4" />
          </div>
          <p className="mt-4 text-[#4A4F46] leading-relaxed whitespace-pre-line">
            {branding.login_subtitle}
          </p>
        </div>

        <form
          onSubmit={onSubmit}
          className="bg-white/80 backdrop-blur rounded-2xl border border-[#E5DFD3] p-8 shadow-[0_8px_40px_-20px_rgba(72,99,74,0.25)]"
          data-testid="login-form"
        >
          <label className="label-eyebrow block mb-3" htmlFor="pw">Passwort</label>
          <input
            id="pw"
            type="password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            placeholder="Familien-Passwort"
            className="w-full bg-[#FDFBF7] border border-[#E5DFD3] rounded-xl px-4 py-3.5 text-lg focus:outline-none focus:ring-2 focus:ring-[#48634A]/40 focus:border-[#48634A] text-[#1A1C19] placeholder:text-[#4A4F46]/50"
            autoFocus
            required
            data-testid="login-password-input"
          />
          <button
            type="submit"
            disabled={busy || !pw}
            className="btn-primary mt-5 w-full rounded-xl py-3.5 font-medium tracking-wide disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="login-submit-btn"
          >
            {busy ? "Bitte warten …" : "Einladung öffnen"}
          </button>
          <p className="mt-5 text-xs text-center text-[#4A4F46]">
            Das Passwort hast du in der Einladungskarte erhalten.
          </p>
        </form>
      </div>
    </div>
  );
}
